module.exports = __webpack_public_path__ + "img/expand-white.048c9fb9.svg";